import React, {Component} from 'react'
import PropTypes from 'prop-types'
import NoLabels from './NoLabels'
import LabelsList from './LabelsList'
import {Spin} from 'antd'

class LabelsTable extends Component {
    _renderTableContent = () => {
        const {labels, onFetchLabels} = this.props

        if (labels.length === 0) {
            return <NoLabels/>
        }

        return <LabelsList labels={labels} onFetchLabels={onFetchLabels}/>
    }

    render() {
        const tableContent = this._renderTableContent()
        const {loading} = this.props

        return (
            <div className='LabelsTable'>
                <Spin spinning={loading} tip='Loading...'>
                    <table className='table table-borderless table-striped'>
                        <thead className='thead-light'>
                        <tr>
                            <th className='Barcode'>Mã đơn</th>
                            <th className='LabelPreview'>Nhãn</th>
                            <th className='TrackingCarrier'>Tracking carrier</th>
                            <th className='TrackingNumber'>Tracking number</th>
                            <th className='CreatedDate'>Ngày tạo</th>
                            <th className='LabelNote'>Note</th>
                            <th className='LabelType'>Loại</th>
                            <th>Hành động</th>
                        </tr>
                        </thead>
                        <tbody>
                        {tableContent}
                        </tbody>
                    </table>
                </Spin>
            </div>
        )
    }
}

LabelsTable.propTypes = {
    labels: PropTypes.array.isRequired,
    onFetchLabels: PropTypes.func.isRequired,
}

export default LabelsTable
